<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-12-10 16:40:25
-->
<template>
  <div class="background-contain">
    <div class="page-contain">
      <div class="body">
        <div class="right-contain">
          <div class="right-contain-tip1">Sofincore</div>
          <div class="right-contain-tip1 technologies-limited">technologies limited</div>
          <div class="right-contain-tip2">{{ $t("components.firstPart.462772-3") }}</div>

          <!-- 移动端显示图片 -->
          <img class="phone-right-img" src="@/assets/img2@3x-en.png" alt="" />
          <div class="phone-down-contain">
            <!-- Download functionality commented out -->
            <div slot="reference" class="right-contain-tip3">
              <img src="@/assets/ios-icon02.png" class="btn-icon" alt="" />
              <!-- <img v-else src="@/assets/ios-icon01.png" class="btn-icon" alt="" /> -->
              <div class="ios-btn">
                <div class="ios-title1">Download on the</div>
                <div class="ios-title2">App Store</div>
              </div>
            </div>
            <!-- Download functionality commented out -->
            <div slot="reference" class="right-contain-tip4 and-btn">
              <img src="@/assets/goo@2x.png" class="btn-icon" alt="" />
              <div class="ios-btn">
                <div class="ios-title1">Download on the</div>
                <div class="ios-title2">Google Play</div>
              </div>
            </div>
          </div>

          <div class="down-contain">
            <!-- Hover disabled, download functionality commented out -->
            <el-popover placement="bottom" title="" trigger="hover" content="" popper-class="poppers" :disabled="true">
              <div slot="reference" class="right-contain-tip3">
                <img src="@/assets/ios-icon02.png" class="btn-icon" alt="" />
                <!-- <img src="@/assets/ios-icon01.png" class="btn-icon" alt="" /> -->
                <div class="ios-btn">
                  <div class="ios-title1">Download on the</div>
                  <div class="ios-title2">App Store</div>
                </div>
              </div>
            </el-popover>
            <!-- Hover disabled, download functionality commented out -->
            <el-popover placement="bottom" title="" trigger="hover" content="" popper-class="poppers" :disabled="true">
              <div slot="reference" class="right-contain-tip4" style="margin-left: 16px">
                <img src="@/assets/goo@2x.png" class="btn-icon" alt="" />
                <div class="ios-btn">
                  <div class="ios-title1">Download on the</div>
                  <div class="ios-title2">Google Play</div>
                </div>
              </div>
            </el-popover>
          </div>
          <div style="text-align: left; margin-top: 20px; color: #ffffff; font-size: 14px;">
            <div>{{ $t("components.firstPart.coming-soon") }}</div>
            <div style="margin-top: 8px;">{{ $t("components.firstPart.enterprise-only") }}</div>
          </div>
        </div>
        <img class="right-img" src="@/assets/img2@3x-en.png" alt="" />
      </div>
      <div class="footer">
        <div class="footer-title">{{ $t("components.firstPart.462772-5") }}</div>
        <div class="img-contain">
          <img class="brand-icon" src="@/assets/img/iconEbay@3x.png" alt="Ebay" />
          <img class="brand-icon" src="@/assets/img/iconAribnb@3x.png" alt="Airbnb" />
          <img class="brand-icon" src="@/assets/img/iconWalmart@3x.png" alt="Walmart" />
          <img class="brand-icon" src="@/assets/img/iconEtsy@3x.png" alt="Etsy" />
          <img class="brand-icon" src="@/assets/img/iconSteam@3x.png" alt="Steam" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "firstPart",
  props: {
    msg: String,
  },
  data() {
    return {
      acitve: 0,
      env: process.env.NODE_ENV,
    };
  },
  methods: {
    // 下载逻辑已注释
    // toDownload(type) {
    //   if (type == 1) {
    //     if (process.env.NODE_ENV == "production") location.href = "https://play.google.com/store/apps/details?id=com.bytelink.cregispay.card";
    //   } else if (type == 2) {
    //     if (process.env.NODE_ENV == "production") location.href = "https://www.pgyer.com/vtronceshi";
    //   } else {
    //     if (process.env.NODE_ENV == "production") {
    //       location.href = "https://file.vcard-usa.com/app/vtron.apk";
    //     } else {
    //       location.href = "https://file.vcard-usa.com/app/vtron.apk";
    //     }
    //   }
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-popover .el-popper .poppers {
  min-width: 135px !important;
  width: 135px !important;
  padding: 0;
}
</style>
<style src="./firstPartCss/max.css" scoped></style>
<style src="./firstPartCss/middle.css" scoped></style>
<style src="./firstPartCss/flat.css" scoped></style>
<style src="./firstPartCss/min.css" scoped></style>
